import type { CSSProperties } from "react"

export type DurabilityLevel = "healthy" | "worn" | "critical"

export const DURABILITY_COLORS: Record<DurabilityLevel, string> = {
  healthy: "#3FBA34",
  worn: "#FFD180",
  critical: "#FF4741"
}

export const getDurabilityFill = (current: number, max: number): number => {
  if (max <= 0) {
    return 0
  }
  return Math.max(0, Math.min(1, current / max))
}

export const getDurabilityLevel = (ratio: number): DurabilityLevel => {
  if (ratio >= 0.5) {
    return "healthy"
  }
  if (ratio >= 0.2) {
    return "worn"
  }
  return "critical"
}

export const getDurabilityStyle = (ratio: number): CSSProperties =>
  ({
    "--durability-color": DURABILITY_COLORS[getDurabilityLevel(ratio)]
  }) as CSSProperties
